import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

const pathMapping = {
  down: 'm6 10 6 6 6 -6',
  left: 'm14 6 -6 6 6 6',
  right: 'm10 6 6 6-6 6',
  up: 'm6 14 6 -6 6 6',
};

type PropsType = SVGComponentPropsType & {
  orientation?: keyof typeof pathMapping;
};

export default ({ color = defaultIconColor, size = defaultSize, orientation = 'down', ...props }: PropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <path stroke={color} strokeWidth="2" d={pathMapping[orientation]} fill="none" fillRule="evenodd" />
  </svg>
);
